import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function CompanyDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const companyDetails = location.state?.companyDetails || {};

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/companies")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                Company Details of :  {companyDetails.company_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">State Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="state_name"
                                                        readOnly
                                                        value={companyDetails.state_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">City Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="city_name"
                                                        readOnly
                                                        value={companyDetails.city_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Company Name</label>
                                                    <input
                                                        type="text"
                                                        name="company_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={companyDetails.company_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={companyDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompanyDetails;
